import queryString from "query-string";
import { server_url } from "../constants/types";
import { apiCallAction } from "./actionUtils";
import ActionConstants from "../constants";
import { showAppApiAlert } from "./appActions";
import { removeObjectKeys } from "core/utils/appUtils";

export const createChangeOrderAction = ({
  formData,
  onSuccess,
  params = {},
}) => {
  return apiCallAction({
    requestMethod: formData?.changeOrderId ? "PUT" : "POST",
    requestUrl: `${server_url}/changeOrder${
      formData?.changeOrderId ? `/${formData.changeOrderId}` : ""
    }`,
    requestData: formData,
    actionType: ActionConstants.CREATE_CHANGE_ORDER,
    successType: ActionConstants.CREATE_CHANGE_ORDER_SUCCESS,
    errorType: ActionConstants.CREATE_CHANGE_ORDER_ERROR,
    successCallback: (response, dispatch) => {
      dispatch({
        type: ActionConstants.CREATE_CHANGE_ORDER_SUCCESS,
        payload: {
          changeOrderList: response.data.items,
          totalCount: response.data.totalCount,
        },
      });
      onSuccess();
      // dispatch(fetchChangeOrdersAction(params));
    },
  });
};

export const fetchChangeOrdersAction = (params) => {
  return apiCallAction({
    requestMethod: "GET",
    requestUrl: `${server_url}/changeOrder?${queryString.stringify(params)}`,
    actionType: ActionConstants.CHANGE_ORDER_GET_ALL,
    successType: ActionConstants.CHANGE_ORDER_GET_ALL_SUCCESS,
    errorType: ActionConstants.CHANGE_ORDER_GET_ALL_ERROR,
    successCallback: (response, dispatch) => {
      dispatch({
        type: ActionConstants.CHANGE_ORDER_GET_ALL_SUCCESS,
        payload: {
          changeOrdersList: response.data.items,
          totalCount: response.data.totalCount,
        },
      });
    },
  });
};

export const fetchChangeOrderByIdAction = (id) => {
  return apiCallAction({
    requestMethod: "GET",
    requestUrl: `${server_url}/changeOrder/${id}`,
    actionType: ActionConstants.CHANGE_ORDER_GET_BY_ID,
    successType: ActionConstants.CHANGE_ORDER_GET_BY_ID_SUCCESS,
    errorType: ActionConstants.CHANGE_ORDER_GET_BY_ID_ERROR,
    successCallback: (response, dispatch) => {
      dispatch({
        type: ActionConstants.CHANGE_ORDER_GET_BY_ID_SUCCESS,
        payload: response.data,
      });
    },
  });
};

export const fetchChangeOrderStatusAction = (currentStatus, propertyId=null) => {
  return apiCallAction({
    requestMethod: "GET",
    requestUrl: `${server_url}/changeOrderStatus?currentState=${currentStatus}${propertyId ? `&propertyId=${propertyId}` : ''}`,
    actionType: ActionConstants.CHANGE_ORDER_STATUS_GET_ALL,
    successType: ActionConstants.CHANGE_ORDER_STATUS_GET_ALL_SUCCESS,
    errorType: ActionConstants.CHANGE_ORDER_STATUS_GET_ALL_ERROR,
    successCallback: (response, dispatch) => {
      dispatch({
        type: ActionConstants.CHANGE_ORDER_STATUS_GET_ALL_SUCCESS,
        payload: response.data,
      });
    },
  });
};

export const deleteChangeOrderAction = (orderId, onSuccess = () => {}) => {
  return apiCallAction({
    requestMethod: "DELETE",
    requestUrl: `${server_url}/changeOrder/${orderId}`,
    actionType: ActionConstants.CHANGE_ORDER_DELETE,
    successType: ActionConstants.CHANGE_ORDER_DELETE_SUCCESS,
    errorType: ActionConstants.CHANGE_ORDER_DELETE_ERROR,
    successCallback: (response, dispatch) => {
      dispatch(
        showAppApiAlert({
          showAlert: true,
          type: "success",
          message: "Change Order deleted successfully",
        })
      );
      dispatch({
        type: ActionConstants.CHANGE_ORDER_DELETE_SUCCESS,
        payload: response.data,
      });
      onSuccess();
    },
    errorCallback: (error, dispatch) => {
      dispatch(
        showAppApiAlert({
          type: "error",
          message: error.message || "Failed to delete Change Order",
        })
      );
    },
  });
};

export const updateChangeOrderStatusAction = ({
  newStatus,
  currentChangeOrderData,
  onSuccess,
  params = {},
}) => {
  const formData = {
    ...currentChangeOrderData,
    changeOrderStatusId: newStatus.key,
    changeOrderStatusReqResp: newStatus.data,
  };
  return apiCallAction({
    requestMethod: currentChangeOrderData?.changeOrderId ? "PUT" : "POST",
    requestUrl: `${server_url}/changeOrder${
      currentChangeOrderData?.changeOrderId
        ? `/${currentChangeOrderData.changeOrderId}`
        : ""
    }`,
    requestData: formData,
    actionType: ActionConstants.UPDATE_CHANGE_ORDER_STATUS,
    successType: ActionConstants.UPDATE_CHANGE_ORDER_STATUS_SUCCESS,
    errorType: ActionConstants.UPDATE_CHANGE_ORDER_STATUS_ERROR,
    successCallback: (response, dispatch) => {
      dispatch(
        showAppApiAlert({
          showAlert: true,
          type: "success",
          message: `Change Order status updated to ${newStatus.text} successfully`,
        })
      );
      dispatch({
        type: ActionConstants.UPDATE_CHANGE_ORDER_STATUS_SUCCESS,
        payload: {

        },
      });
      onSuccess(formData);
      // dispatch(fetchChangeOrdersAction(params));
    },
  });
};

export const clearChangeOrderData = () => {
  return (dispatch) => {
    dispatch({
      type: ActionConstants.CHANGE_ORDER_GET_BY_ID_SUCCESS,
      payload: null,
    });
  };
};
